<script setup>
import { ref } from 'vue';
const props = defineProps({
    position: {
        type: String,
        default: 'top',
    }
})

const timer = ref(null);

const isShown = ref(false);

const show = ( to = 500 ) => {
    clearTimeout(timer.value);
    timer.value = setTimeout(() => {
        isShown.value = true;
        clearTimeout(timer.value);
    }, to)
}

const hide = ( to = 500 ) => {
    clearTimeout(timer.value);
    timer.value = setTimeout(() => {
        isShown.value = false;
        clearTimeout(timer.value);
    }, to)
}
</script>
<template>
    <div class="w-content relative" @mouseleave="hide(300)">
        <div v-bind="$attrs" @mouseenter="show(800)">
            <slot name="default" v-if="$slots.content" />
            <svg @click.prevent="isShown ? hide(0) : show(0)" tabindex="1" xmlns="http://www.w3.org/2000/svg" v-else
                class="outline-none fill-current w-4 cursor-pointer opacity-40 hover:opacity-100 transition" viewBox="0 0 16 16">
                <path
                    d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2" />
            </svg>
        </div>
        <transition name="slide">
            <div
            @click.stop
            v-if="isShown"
            class="absolute font-normal z-30 top-1/2 -translate-y-1/2 left-8 text-sm w-max min-w-xs max-w-sm py-2 px-4 sm:px-6 sm:py-4 shadow-lg rounded-md  bg-slate-800 text-slate-100 before:content-[''] before:absolute before:top-1/2 before:-translate-y-1/2 before:bg-slate-800 before:w-6 before:h-6 before:rotate-45 before:right-full before:translate-x-5">
            <slot :name="!$slots.content ? 'default' : 'content'" />
        </div>
        </transition>
    </div>
</template>